// extracted by mini-css-extract-plugin
export default {"displayedNote":"displayedNote--34ySU"};